/**
 * Productivity hack - Import all vuex modules automatically
 */
import camelCase from 'lodash/camelCase';
const files = require.context('.', false, /\.js$/);
const modules = {};

/**
 * Default reset method(mutation) which will be inserted in every index.
 * @param state
 * @param module
 */
const reset = function (state, module) {
	const s = module.initialState();
	Object.keys(s).forEach(key => {
		state[key] = s[key]
	})
};

files.keys().forEach(fileName => {
  if (fileName === './index.js') return;
  const moduleName = camelCase(fileName.replace(/(\.\/|\.js)/g, ''));
	files(fileName).default.mutations.reset = reset;
  modules[moduleName] = files(fileName).default;
});

export default modules;
